import React from "react";
import PayrollList from "../../elements/payroll-parts/PayrollList";

export default function Payrolls(props) {


  return (
    <div>
      <PayrollList {...props} />
    </div>
  );
}




